// extracted by mini-css-extract-plugin
export default {"loading__indicator":"Loading_loading__indicator__u3x6e","rotation":"Loading_rotation__V6-dA"};